import React       from 'react';
import DV          from 'ts-data-validator';
import { NavLink } from 'react-router-dom';

import { Divider } from '../../../../components';

function SitemapItem(props) {
  const {
          item,
          onClick,
        } = props;

  const isEmpty = (item) => {
    if (DV.isNotEmptyArray(item.pages)) {
      return !item.pages.map(isEmpty)
        .includes(false);
    } else {
      return !item.url;
    }
  };

  if (isEmpty(item)) {
    return null;
  }

  const hasItems = DV.isNotEmptyArray(item.pages);

  return (
    <div>
      {hasItems ? (
        <>
          {item.pages.map((subItem, subItemIndex) => (
            <>
              {subItem.pages.length > 0 ? (
                <div className={'sub-menu'}>
                  <h5> {subItem.label} </h5>
                  <Divider />
                  <SitemapItem
                    key={subItemIndex}
                    {...props}
                    item={subItem}
                  />
                </div>
              ) : (
                <SitemapItem
                  key={subItemIndex}
                  {...props}
                  item={subItem}
                  onClick={onClick}
                />
              )}
            </>
          ))}
        </>
      ) : (
        <>
          {item.url.startsWith('http') ? (
            <a
              href={item.url}
              target={'_blank'}
              rel={'nofollow noindex noreferrer'}
            >
              <h6>{item.label}</h6>
            </a>) : (
            <NavLink
              to={`/${item.url}`}
              onClick={() => onClick(item)}
            >
              <h6>{item.label}</h6>
            </NavLink>)}
        </>
      )}
    </div>
  );
}

export default SitemapItem;